<dp-login [hasError]="hasError"
          [hasLoginMethodsError]="hasOtherLoginError"
          [errorKey]="error"
    [errorParameters]="errorParameters"
          [pattern]="pattern"
          [loginMethods]="providers"
          (login)="doLogin($event)"
          (loginMethod)="otherLoginMethod($event)">
</dp-login>
